
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import DefaultMeta from "@utils/DefaultMeta";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import Authentication from "@components/Authentication";
import { usePersistLocaleCookie } from "@utils/usePersistLocaleCookie";
import useTranslation from "next-translate/useTranslation";
import noval from "noval";
import createState from "@utils/noval-helper/create-state";
import createDispatch from "@utils/noval-helper/create-dispatcher";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Theme } from "@components/UI/Theme";
import "react-toastify/dist/ReactToastify.min.css";
import "../styles/globals.css";
import dynamic from "next/dynamic";
const ToastContainer = dynamic(() => import("react-toastify").then((mod) => mod.ToastContainer), { ssr: false });
const IntercomBot = dynamic(() => import("@components/Intercom/IntercomBot"), {
    ssr: true
});
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false
        }
    }
});
const ProviderNoval = noval(createState, createDispatch);
function AseelApp({ Component, pageProps }) {
    const { lang } = useTranslation();
    const { query, pathname } = useRouter();
    const isAppQuery = query.app === "true";
    usePersistLocaleCookie();
    useEffect(() => {
        let background = `linear-gradient(${lang === "ar" ? "275.01deg" : "95.01deg"}, #05128B 0.06%, #2B64F5 105.54%, #5CAEFF 136.9%)`;
        if (document) {
            document.body.style.background = background;
            document.documentElement.style.background = background;
            document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
            document.body.dir = lang === "ar" ? "rtl" : "ltr";
        }
    }, [lang]);
    const cache = useMemo(() => {
        return createCache({
            key: lang === "ar" ? "muirtl" : "mui"
        });
    }, [lang]);
    return (<>
      <DefaultMeta />
      <Theme>
        <CacheProvider value={cache}>
          <ProviderNoval>
            <QueryClientProvider client={queryClient}>
              <IntercomBot lang={lang} pathname={pathname} isAppQuery={isAppQuery}/>
              <Authentication lang={pageProps?.__lang}>
                <Component {...pageProps}/>
              </Authentication>
              {!isAppQuery && (<ToastContainer position={lang === "en" ? "top-right" : "top-left"} rtl={lang === "ar"}/>)}
            </QueryClientProvider>
          </ProviderNoval>
        </CacheProvider>
      </Theme>
    </>);
}
const __Next_Translate__Page__19855f1ac1d__ = AseelApp;

    export default __appWithI18n(__Next_Translate__Page__19855f1ac1d__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  